var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light"},[_c('mobile-header',[_c('div',{staticClass:"pl-2"},[_c('brand-link')],1)]),_c('div',{staticClass:"d-block",attrs:{"id":"main"}},[(_vm.$route.meta.public)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }